import { toTitleCaseUi } from "@/shared/utils/titleCase";
import { Plus } from "lucide-react";
import { ReactNode, useState } from "react";

type CollapsibleFieldProps = {
  label: string;
  children: ReactNode;
  defaultOpen?: boolean;
};

const CollapsibleField = ({ label, children, defaultOpen = false }: CollapsibleFieldProps) => {
  const [open, setOpen] = useState(defaultOpen);
  const labelText = toTitleCaseUi(label);

  return (
    <div className="space-y-3">
      <button
        type="button"
        className="flex items-center gap-3 text-left text-[13px] font-semibold text-theme-text"
        onClick={() => setOpen((current) => !current)}
      >
        <Plus className="h-5 w-5 shrink-0" />
        <span>{labelText}</span>
      </button>

      {open ? <div className="pl-8">{children}</div> : null}
    </div>
  );
};

export default CollapsibleField;
